import { render, staticRenderFns } from "./officialOrder.vue?vue&type=template&id=272accbe&scoped=true"
import script from "./officialOrder.vue?vue&type=script&lang=js"
export * from "./officialOrder.vue?vue&type=script&lang=js"
import style0 from "./officialOrder.vue?vue&type=style&index=0&id=272accbe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272accbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('272accbe')) {
      api.createRecord('272accbe', component.options)
    } else {
      api.reload('272accbe', component.options)
    }
    module.hot.accept("./officialOrder.vue?vue&type=template&id=272accbe&scoped=true", function () {
      api.rerender('272accbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/selfOfficialOrder/officialOrder.vue"
export default component.exports